import { useAuth } from '@/auth/useAuth';
import { useSessionAvatar } from '@/hooks/useSessionAvatar';

import { ProfileAvatar } from './ProfileAvatar';

export interface SessionAvatarProps {
  size?: number;
}

/**
 * The signed-in user's avatar, wired to the app-wide avatar state (`AvatarProvider`): shows their
 * uploaded photo everywhere it's mounted (top bar, account profile, future Recruiter/Company/
 * Messages/Notifications surfaces) and falls back to initials when no photo exists. Because it reads
 * the shared context, uploading a new photo updates every instance instantly — no refresh.
 */
export function SessionAvatar({ size = 40 }: SessionAvatarProps) {
  const { user } = useAuth();
  const { photoUrl } = useSessionAvatar();

  return (
    <ProfileAvatar
      firstName={user?.firstName ?? ''}
      lastName={user?.lastName ?? ''}
      imageUrl={photoUrl}
      size={size}
    />
  );
}
